import styled from 'styled-components';
import { WhiteSectionCss } from '../AllContributorsDoraDashboard.style';
import { StyledWidgetBox } from '../../GroupDashboard/GroupMetricsWidget/GroupMetricsWidgetNew';

export const StyledMetricWidget = styled.div`
  ${WhiteSectionCss};

  & ${StyledWidgetBox} {
    width: 100%;
  }
`;
